import { FormControl } from '@angular/forms';

const eanDunRegex = /^(\d{8}|\d{12}|\d{13}|\d{14}|\d{18})$/;
const eanSapRegex = /^(1{1}0{7})\d{6}$/;

function isValidEAN(value: string): boolean {
  const digits = value.split('').map(Number);
  const checkDigit = digits.pop(); // último dígito
  let sum = 0;

  // percorre da direita para a esquerda
  digits.reverse().forEach((digit, i) => {
    sum += digit * (i % 2 === 0 ? 3 : 1);
  });

  const calculatedCheckDigit = (10 - (sum % 10)) % 10;
  return checkDigit === calculatedCheckDigit;
}

export function validateEanDun() {
  return (control: FormControl) => {
    const value: string = control.value;

    if (!value) {
      return null;
    }

    if (eanSapRegex.test(value)) {
      return null;
    }

    if (!eanDunRegex.test(value)) {
      return {
        eanDun: 'Deve possuir 8, 12, 13, 14, ou 18 caracteres',
      };
    }

    if (!isValidEAN(value)) {
      return {
        eanDun: 'Código Inválido',
      };
    }

    return null;
  };
}
